import type React from "react";
import { Grid, type GridProps } from "@/shared/ui";

export interface IconBoxGridProps extends GridProps {}

export const IconBoxGrid: React.FC<IconBoxGridProps> = ({
	cols = { xl: 3, lg: 2 },
	gap = {
		xs: 2,
		lg: 4,
	},
	...props
}) => {
	return <Grid gap={gap} cols={cols} {...props} />;
};
